<template>
  <div class="facet-element">
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        :id="`facet-toggle-${name}`"
        :checked="isInContext(value)"
        :value="value"
        @change="updateContext(value)"
      >
      <label class="form-check-label" :for="`facet-toggle-${name}`">{{ label }}</label>
      <facet-info-tooltip
        v-if="tooltip"
        :text="tooltip.text"
        :link-url="tooltip.linkUrl"
        :link-text="tooltip.linkText"
      />
    </div>
  </div>
</template>

<script>
import { store } from '../../../../store.js'
import FacetInfoTooltip from './FacetInfoTooltip.vue'

export default {
  name: "CheckBoxType",
  props: ['name', 'label', 'value', 'tooltip'],
  components: { FacetInfoTooltip },
  data() {
    return {
      store,
    }
  },
  methods: {
    isInContext(value) {
      if(!this.store.context.hasOwnProperty(this.name) || this.store.context[this.name] === null) {
        return false;
      }

      return store.context[this.name].includes(value);
    },
    updateContext(value) {
       if(!this.store.context.hasOwnProperty(this.name)) {
         console.info('Could not find filter ', this.name);
         return
       }

       if (this.store.context[this.name] === null) {
         this.store.context[this.name] = [];
       }

       if(this.store.context[this.name].includes(value)) {
          this.store.context[this.name] = this.store.context[this.name].filter(key => key !== value)
       } else {
          this.store.context[this.name] = [...this.store.context[this.name], value]
       }

       this.store.updateSearchResults(true);
    }
  }
}
</script>

<style scoped>

</style>
